// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1ViJW";
export var grid = "styles-module--grid--2JIqT";
export var logo = "styles-module--logo--1Bce4";
export var socialContainer = "styles-module--socialContainer--2ECmq";
export var legalContainer = "styles-module--legalContainer--2HRWJ";
export var iconsContainer = "styles-module--iconsContainer--3i12p";
export var linksContainer = "styles-module--linksContainer--1ajj8";
export var disclaimer = "styles-module--disclaimer--2Vhu7";
export var copy = "styles-module--copy--3Kb3d";